import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';
import { TipoRol } from '@rpe/registro-personas-empresas-lib/src/lib/tipos-rol/tipos-rol.model';

// LOAD
export const entityTiposRolLoadRequest = createAction(
  '[ENTITYTIPOSROL] Load Request'
);

export const entityTiposRolLoadFailure = createAction(
  '[ENTITYTIPOSROL] Load Failure',
  props<{ error: Error }>()
);

export const entityTiposRolLoadSuccess = createAction(
  '[ENTITYTIPOSROL] Load Success',
  props<{ items: TipoRol[] }>()
);

export const entityTiposRolUpdateSuccess = createAction(
  '[ENTITYTIPOSROL] Update Success',
  props<{ update: TipoRol }>()
);
